
export default {
  name: 'SghFileUploader',
  props: {
    loaded: {
      type: Boolean,
      default: false,
    },
    loading:{
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: '',
    },
    maxFileSize: {
      type: Number,
      default: null,
    },
  },
  emits: ['fileDeleted','fileSelected','fileValidated'],
  methods: {
    uploadFile() {
      this.$refs.fileInput.click()
    },
    deleteFile(){
      this.file = null
      this.$refs.fileInput.value = null
      this.$emit('fileDeleted')
    },
    async handleFileChange(event) {
      const file = event.target.files[0]
      const fileValidation = this.validateFile(file)

      if (!fileValidation.valid) {
        this.$emit('fileValidated', {
          ...fileValidation,
          name: file.name,
        })
        return
      }
      this.toBase64(file).then(fileData => {
        this.$emit('fileValidated', {
          ...fileValidation,
          fileData,
          name: file.name,
        })
      }).catch(error => {
        console.error('Error converting file to base64:', error)
      })
    },
    validateFile(file) {
      const fileTypeAllowed = this.accept.split(',')
      if (!file?.name) {
        return {
          valid: false,
          errorType: 'NO_FILE',
        }
      } else if (file?.size > this.megabytesToBytes(this.maxFileSize)) {
        return {
          valid: false,
          errorType: 'SIZE',
        }
      } else if (fileTypeAllowed.indexOf(file?.type) === -1) {
        return {
          valid: false,
          errorType: 'TYPE',
        }
      } else {
        return {
          valid: true,
        }
      }
    },

    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result.substr(reader.result.indexOf('base64') + 7))
        reader.onerror = error => reject(error)
      })
    },
    megabytesToBytes(megabytes) {
      if (typeof megabytes !== 'number' || megabytes < 0) {
        throw new Error('Input must be a non-negative number.')
      }
      return megabytes * 1024 * 1024
    },
  },

}
